"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesManagerSymbol = exports.ServiceProviderSymbol = void 0;
exports.ServiceProviderSymbol = Symbol('ServiceProvider');
exports.ServicesManagerSymbol = Symbol('ServicesManager');
//# sourceMappingURL=service.js.map